import { FlyerHeader } from "./features/flyer-header/components/flyer-header/flyer-header.component";
import { PAGES } from "../../features/navigation/types/pages.constant";
import { FlyerDetail } from "./pages/flyer-detail/components/flyer-detail/flyer-detail.component";
import { getIdPath } from "../../features/navigation/types/pages.functions";
import { Flyer } from "./components/flyer/flyer.component";
import { FlyerDetailRoutes } from "./pages/flyer-detail/flyer-detail.routes";
import { IRoute } from "../../types/routing/iroute.interface";

export const FlyerRoutes: IRoute[] = [
  ...FlyerDetailRoutes,
  {
    component: FlyerDetail,
    path: getIdPath(PAGES.FLYERS.URL),
  },
  {
    component: Flyer,
    header: FlyerHeader,
    path: PAGES.FLYERS.URL,
  },
];
